import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAppStore from '../../stores/useAppStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
  showLoginModal?: boolean;
}

export default function ProtectedRoute({ 
  children, 
  redirectTo = '/', 
  showLoginModal = false 
}: ProtectedRouteProps): JSX.Element | null {
  const { isAuthenticated, openLoginModalClean } = useAppStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      if (showLoginModal) {
        // Show login modal instead of redirecting
        openLoginModalClean();
      } else {
        // Redirect to specified route
        navigate(redirectTo);
      }
    }
  }, [isAuthenticated, navigate, redirectTo, showLoginModal, openLoginModalClean]);

  // If not authenticated, don't render the protected content
  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
